import '.h{display:grid;}.ssr-plugin'
import '.j{gap:1.5rem;}.ssr-plugin'
import Column from '@app/components/layout/Column'
import { useCallback, type Dispatch, type SetStateAction } from 'react'
import { useQuery } from '@based/sdk/react'
import { AmenityListModel } from 'functions/app/amenity/list'
import { AmenityCard } from '@app/pages/dashboard/initiative/shared/forms/amenities/blocks/AmenityCard'
import { AddCustomAmenityCard } from '@app/pages/dashboard/initiative/shared/forms/amenities/blocks/AddCustomAmenityCard'
import { styled } from 'inlines'

export const MAX_CUSTOM_AMENITIES = 6

export type AmenitiesSelectionGridProps = {
  initiativeId: number
  selectedIds: number[]
  setSelectedIds: Dispatch<SetStateAction<number[]>>
  variant?: 'narrow' | 'wide'
}

export const AmenitiesSelectionGrid = ({
  initiativeId,
  selectedIds,
  variant = 'narrow',
  setSelectedIds,
}: AmenitiesSelectionGridProps) => {
  const amenitiesQuery = useQuery('list-amenities', {
    initiativeId,
  })
  const amenities: AmenityListModel[] = amenitiesQuery.data ?? []

  const toggleAmenity = useCallback(
    (id: number) => {
      setSelectedIds((prev) => {
        const i = prev.indexOf(id)
        return i > -1 ? prev.toSpliced(i, 1) : [...prev, id]
      })
    },
    [setSelectedIds],
  )

  const addSelectedId = useCallback(
    (id: number) => {
      setSelectedIds((prev) => (prev.includes(id) ? prev : [...prev, id]))
    },
    [setSelectedIds],
  )

  const canAddCustom =
    amenities.filter((a) => a.custom).length < MAX_CUSTOM_AMENITIES

  return (
    <Column gap="1.5rem" alignItems="center">
      <div className="h j"
        style={{
          gridTemplateColumns:
            variant === 'narrow'
              ? 'repeat(3, 6.875rem)'
              : 'repeat(6, 6.875rem)',}}
      >
        {amenities.map((a) => (
          <AmenityCard
            key={a.id}
            label={a.name}
            iconName={a.iconName}
            selected={selectedIds.includes(a.id)}
            onClick={() => toggleAmenity(a.id)}
          />
        ))}
        {canAddCustom && (
          <AddCustomAmenityCard
            initiativeId={initiativeId}
            onSelectId={addSelectedId}
          />
        )}
      </div>
    </Column>
  )
}
